// PHASE 4: What environments make you feel most alive?
import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'designInfluences'

const OPTIONS = [
  {
    value: 'Boutique hotels',
    translationKey: 'pages.onboarding.v2.designInfluences.options.hotels',
    emoji: '🏨',
  },
  {
    value: 'Nature and outdoors',
    translationKey: 'pages.onboarding.v2.designInfluences.options.nature',
    emoji: '🌿',
  },
  {
    value: 'Trendy cafes',
    translationKey: 'pages.onboarding.v2.designInfluences.options.cafes',
    emoji: '☕',
  },
  {
    value: 'Art galleries',
    translationKey: 'pages.onboarding.v2.designInfluences.options.galleries',
    emoji: '🖼️',
  },
  {
    value: 'Scandinavian homes',
    translationKey: 'pages.onboarding.v2.designInfluences.options.scandinavian',
    emoji: '🇸🇪',
  },
  {
    value: 'Cozy bookshops',
    translationKey: 'pages.onboarding.v2.designInfluences.options.bookshops',
    emoji: '📚',
  },
]

export default function DesignInfluencesPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'What environments make you feel most alive?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.v2.designInfluences.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
